module.exports = __webpack_public_path__ + "static/media/wizualizacja-89.14b5a916.png";